<template>
<div
  class="lamps-document"
  v-if="allDataAlready"
>
  <LampTermGeneric
    v-if="event.doc.companyTerms === 'generic'"
    :power-lamp-delivery-label="event.lamp.powerLampDeliveryLabel"
    :payload="payload"
  />
  <lamp-term-enel-ce
    v-if="`${config.state}` === 'CE' && event.doc.companyTerms === 'enel'"
    :power-lamp-delivery-label="event.lamp.powerLampDeliveryLabel"
    :payload="payload"
  />
  <lamp-term-enel-go
    v-if="`${config.state}` === 'GO' && event.doc.companyTerms === 'enel'"
    :power-lamp-delivery-label="event.lamp.powerLampDeliveryLabel"
    :payload="payload"
  />
  <lamp-term-cemar
    v-if="`${config.state}` === 'MA' && event.doc.companyTerms === 'cemar'"
    :power-lamp-delivery-label="event.lamp.powerLampDeliveryLabel"
    :payload="payload"
  />

  <lamp-term-iasc-ma
    v-if="`${config.state}` === 'MA' && event.doc.companyTerms === 'iasc'"
    :power-lamp-delivery-label="event.lamp.powerLampDeliveryLabel"
    :payload="payload"
  />

  <lamp-term-iasc-al
    v-if="`${config.state}` === 'AL' && event.doc.companyTerms === 'iasc'"
    :power-lamp-delivery-label="event.lamp.powerLampDeliveryLabel"
    :payload="payload"
  />

  <lamp-term-iasc-pi
    v-if="`${config.state}` === 'PI' && event.doc.companyTerms === 'iasc'"
    :power-lamp-delivery-label="event.lamp.powerLampDeliveryLabel"
    :payload="payload"
  />

  <LampTermEquatorialPi
    v-if="`${config.state}` === 'PI' && event.doc.companyTerms === 'equatorial'"
    :power-lamp-delivery-label="event.lamp.powerLampDeliveryLabel"
    :payload="payload"
  />

  <lamp-term-energisa-pb
    v-if="`${config.state}` === 'PB' && event.doc.companyTerms === 'energisa-paraiba'"
    :power-lamp-delivery-label="event.lamp.powerLampDeliveryLabel"
    :payload="payload"
  />
  <lamp-term-energisa-borborema-pb
    v-if="`${config.state}` === 'PB' && event.doc.companyTerms === 'energisa-borborema'"
    :power-lamp-delivery-label="event.lamp.powerLampDeliveryLabel"
    :payload="payload"
  />

  <LampTermCelpa
    v-if="`${config.state}` === 'PA' && event.doc.companyTerms === 'celpa'"
    :power-lamp-delivery-label="event.lamp.powerLampDeliveryLabel"
    :payload="payload"
  />
  <LampTermCelpaJurunas
    v-if="`${config.state}` === 'PA' && event.doc.companyTerms === 'celpa-jurunas'"
    :power-lamp-delivery-label="event.lamp.powerLampDeliveryLabel"
    :payload="payload"
  />
</div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import LampTermEnelCe from './EnelCe/LampTermEnelCe'
import LampTermEnelGo from './EnelGo/LampTermEnelGo'
import LampTermCemar from './Cemar/LampTermCemar'
import LampTermIascPi from './IascPi/LampTermIasc'
import LampTermIascMa from './IascMa/LampTermIasc'
import LampTermIascAl from './IascAl/LampTermIasc'
import LampTermEnergisaBorboremaPb from './EnergisaBorboremaPb/LampTermEnergisaBorboremaPb'
import LampTermEnergisaPb from './EnergisaPb/LampTermEnergisaPb'
import LampTermCelpa from './Celpa/LampTermCelpa'
import LampTermEquatorialPi from './EquatorialPi/LampTermEquatorialPi'
import LampTermCelpaJurunas from './CelpaJurunas/LampTermCelpaJurunas'
import LampTermGeneric from '../../../components/Trg/Terms/LampTermGeneric'

export default {
  name: 'lamps-doccument',

  components: {
    LampTermGeneric,
    LampTermCelpaJurunas,
    LampTermEnelCe,
    LampTermCemar,
    LampTermEnelGo,
    LampTermIascPi,
    LampTermEnergisaPb,
    LampTermIascMa,
    LampTermIascAl,
    LampTermEnergisaBorboremaPb,
    LampTermCelpa,
    LampTermEquatorialPi
  },
  mounted () {
    this.fetchEvent(this.storageData.eventId, true)
      .then(res => {
        this.event = res
      })

    if (!this.config.hasOwnProperty('_id') || !this.config.hasOwnProperty('_rev')) {
      this.fetchProject('config')
    }
  },
  data () {
    return {
      event: {}
    }
  },

  computed: {
    ...mapGetters('project', {
      config: 'project'
    }),

    ...mapGetters('events', { loadingEvent: 'loading' }),

    allDataAlready: function () {
      return this.eventId && this.customer && this.config && this.lamps && this.lampByTypeData && !this.loadingEvent
    },

    payload () {
      return {
        eventId: this.eventId,
        config: this.config,
        customer: this.customer,
        lamps: this.lamps,
        lamp: this.lampByTypeData,
        event: {}
      }
    },

    storageData () {
      return JSON.parse(localStorage.getItem('LampsTmpTemp'))
    },

    eventId () {
      return this.storageData.eventId
    },

    lamps () {
      return this.storageData.lamps
    },

    customer () {
      return this.storageData.customer
    },

    lampByTypeData () {
      return this.storageData.lamps.reduce((acc, curr, indx) => {
        if (indx === 0) {
          acc = {
            fluorescent: { count: 0, text: '' },
            incandescent: { count: 0, text: '' }
          }
        }
        if (curr.type === 'Fluorescente') {
          acc.fluorescent.count++
          acc.fluorescent.text += acc.fluorescent.count === 1 ? `${curr.power}W` : `, ${curr.power}W`
        } else if (curr.type === 'Incandescente') {
          acc.incandescent.count++
          acc.incandescent.text += acc.incandescent.count === 1 ? `${curr.power}W` : `, ${curr.power}W`
        }
        return acc
      }, {})
    }
  },

  methods: {
    ...mapActions('project', { fetchProject: 'fetchOne' }),
    ...mapActions('events', { fetchEvent: 'fetchOne' })
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/Documents/Terms/LampsDocument.vue